var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4445 36.8485C28.631 36.8485 36.8889 28.5997 36.8889 18.4242C36.8889 8.24881 28.631 0 18.4445 0C8.25786 0 0 8.24881 0 18.4242C0 28.5997 8.25786 36.8485 18.4445 36.8485Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67607 18.2646L20.0968 13.1527C21.3228 12.6202 25.4808 10.9162 25.4808 10.9162C25.4808 10.9162 27.3999 10.1707 27.24 11.9812C27.1867 12.7267 26.7602 15.3359 26.3338 18.1581L25.0011 26.5182C25.0011 26.5182 24.8944 27.743 23.9882 27.956C23.082 28.169 21.5894 27.2105 21.3228 26.9975C21.1096 26.8377 17.3248 24.4415 15.9388 23.27C15.5656 22.9505 15.1391 22.3115 15.9921 21.5661C17.9111 19.8088 20.2034 17.6256 21.5894 16.2411C22.2291 15.6021 22.8688 14.1112 20.2034 15.9216L12.687 20.9803C12.687 20.9803 11.8341 21.5128 10.2348 21.0336C8.63561 20.5543 6.76984 19.9153 6.76984 19.9153C6.76984 19.9153 5.49046 19.1166 7.67607 18.2646Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ac299d3d6727f1192704c64b180a6aeb.svg";
export { ForwardRef as ReactComponent };